import { HOST } from "../constants/HostConstants";
import { fetchWithRetry } from "../utils/apiRetry";

const sanitizeUser = (user) => {
  if (!user || typeof user !== "object") return null;
  const { password: pwd, ssn, ...rest } = user;
  return rest;
};

export const loginUser = async (
  credential,
  password,
  setUser,
  setSuccess,
  setErr,
  { setWaitingMessage = null } = {}
) => {
  try {
    setErr?.(null);
    if (setWaitingMessage) setWaitingMessage("Logging in...");

    const res = await fetchWithRetry(
      `${HOST}/api/user/userAuth`,
      {
        method: "POST",
        body: JSON.stringify({ credential, password }),
        credentials: "include",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      },
      {
        maxRetries: 3,
        initialDelay: 3000,
        onWaiting: (isWaiting, message) => {
          if (setWaitingMessage) {
            setWaitingMessage(isWaiting ? message : "Logging in...");
          }
        },
      }
    );

    if (setWaitingMessage) setWaitingMessage(null);

    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }

    // backend sends plain text on failure, so catch it here
    if (!res.ok || typeof data === "string") {
      setUser(null);
      setSuccess(false);
      setErr?.(
        typeof data === "string" ? data : data?.error || "Login failed."
      );
      return;
    }

    setUser(sanitizeUser(data));
    setSuccess(true);
  } catch (e) {
    if (setWaitingMessage) setWaitingMessage(null);
    setUser(null);
    setSuccess(false);
    setErr?.(
      "Login failed. Server may be starting up - please try again in a moment."
    );
  }
};
